import styled, { css } from 'styled-components';
import { StyledEntityItem, EntityIcon, EntityItemContainer } from 'components/Global/EntityItem/styled.js';
import { LabelValue, LabelName, StyledHorizontalFillBar, StackedFillBarLabelContainer, HorizontalBarFill } from 'components/Graphs/FillBars/styled.js';
import { ErrorIconContainer } from 'components/Pages/Reports/ErrorStates/styled.js';

export const ListContainer = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  position: relative;
  padding: 30px;
  margin: 4px;

  ${StyledEntityItem} {
    color: ${({ theme }) => theme.colors.graphPalette[0]};
    text-transform: capitalize;
    vertical-align: bottom;
    font-size: 12px;
  }

  ${LabelValue} {
    color: #2D8BFF;
    font-size: 10px;
    vertical-align: text-bottom;
    height: 18px;
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${LabelName} {
    font-size: 12px;
  }

  @media(max-width: 1300px) {
    padding: 20px;
  }
`;

export const ListBarContainer = styled.div`
  ${StyledHorizontalFillBar} {
    display: inline-block;
    width: 90%;
    padding-left: 15px;

    ${EntityItemContainer} {
      width: 100%;
    }
  }

  ${EntityItemContainer} {
    display: inline-block;
    width: 10%;
  }

  ${StackedFillBarLabelContainer} {
    height: 18px;
    line-height: 17px;
  }

  ${EntityIcon} {
    margin-top: 8px;
  }

  ${LabelValue} {
    ${({ value }) => (value === 0 || value === null) && css`
      color: #E4E5E9;
    `};
  }

  ${HorizontalBarFill} {
    ${({ value }) => (value === 0 || value === null) && css`
      min-width: 0;
    `};
  }

  @media(max-width: 1300px) {
    ${EntityItemContainer} {
      width: 15%;
      padding: 0;
      margin-right: 10px;
    }

    ${StyledHorizontalFillBar} {
      padding-left: 0;
      width: 78%;
    }
  }
`;

export const SocialListContainer = styled(ListContainer)`
  ${LabelName} {
    width: 90%;
  }
  ${LabelValue} {
    width: 10%;
  }

  @media(max-width: 1300px) {
    ${LabelName} {
      width: 80%;
    }

    ${LabelValue} {
      width: 20%;
    }
  }
`;

export const SocialShareWrapper = styled.div`
  @media(min-width: 1300px) {
    ${SocialListContainer}{
      ${EntityItemContainer} {
        width: 5%;
      }

      ${StyledHorizontalFillBar} {
        width: 95%;
      }
    }
  }
  ${ErrorIconContainer} {
    margin-top: 35px;
  }
`;

export const KeywordListContainer = styled(ListContainer)`
  margin: 0;
  text-align: left;
`;

export const ListTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  align-items: center;
  letter-spacing: 1.08649px;
  text-transform: uppercase;
  color: #939AAB;
  margin-bottom: 25px;

  @media(max-width: 1300px) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; 
  }
`;


export const SectionTitle = styled(ListTitle)`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  align-items: center;
  letter-spacing: 1.08649px;
  text-transform: uppercase;
  color: #939AAB;
  margin-bottom: 25px;
`;

export const Section = styled.div`
  position: relative;
  padding: 48px;
  background: white;

  @media(max-width: 1300px) {
    padding: 38px;
  }
`;

export const CreateButton = styled.div`
  background: #2D8BFF;
  border: 1px solid #2D8BFF;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 7px 14px 7px 30px;
  color: white;
  display: inline-block;
  position: absolute;
  right: 36px;
  top: 43px;
  font-weight: bold;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 2px;
  cursor: pointer;

  &:before {
    content: '+';
    position: absolute;
    top: 7px;
    left: 12px;
    font-size: 13px;
  }
`;
